'use strict';

class OrganizationsNewController {
  constructor($q,
              $scope,
              $filter,
              $state,
              utils,
              config,
              LocationsService,
              OrganizationService,
              PermissionsService) {

    // #region Define fields

    const $t = $filter('translate');
    const ORG_BRAND_PROPERTY = 'brand';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';

    $scope.loading = false;
    $scope.minicolorSetting = {
      control: 'hue',
      theme: 'maestro',
      position: 'bottom left'
    };

    $scope.helpers = {
      parentMode: false, // Switch parent orgs
    };

    $scope.allowParentOrgs = PermissionsService.isUnlimitedAdmin();
    $scope.brandEditor = $scope.allowParentOrgs;

    const allOrganizations = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
    $scope.currentOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY); // Current globally selected org
    $scope.parentOrgs = $filter('filter')(allOrganizations, (org) => !org.parentId);
    $scope.choosedOrg = $scope.currentOrg; // Currently selected org

    if ($scope.allowParentOrgs) { // Only for Unlimited Admin
      $scope.helpers.selectedParentOrgId = null;
      $scope.choosedOrg = null;
    } else {
      $scope.helpers.selectedParentOrgId = $scope.choosedOrg ? $scope.choosedOrg.id : $scope.parentOrgs[0].id;
    }

    $scope.featureList = config.getConfigByKey('features');

    // #endregion

    angular.extend($scope, {
      saveOrganization: saveOrganization,
      changeCountry: changeCountry,
      showFeature: showFeature,
      switchParent: switchParent,
    });

    init();

    // #region Methods

    function init() {

      // Watchers
      $scope.$watchGroup([
        'helpers.selectedCountryId',
        'helpers.selectedCountry',
        'countries'
      ], () => $scope.changeCountry());

      $scope.$watch('helpers.selectedParentOrg', (newVal, oldVal) => {
        if (newVal || oldVal) {
          $scope.choosedOrg = $scope.helpers.selectedParentOrg;
        }
      });

      $scope.$watch('choosedOrg.features', () => {
        for (let i = 0; i < $scope.featureList.length; i++) {
          let f = $scope.featureList[i];
          f.disabled = !$scope.showFeature(f.id);
        }
      });

      // Initialize form validation rules
      $.fn.form.settings.rules.zipRule = value => {
        if (!value) {
          return true;
        }
        if ($scope.helpers.selectedCountry && $scope.helpers.selectedCountry.zipFormat) {
          return new RegExp($scope.helpers.selectedCountry.zipFormat).test(value);
        }
        return true;
      };

      $.fn.form.settings.rules.contactEmail = value => !value ? true : $.fn.form.settings.rules.email(value);

      $('#div-org-logo').dimmer({ on: 'hover' });

      $('#form-basic-info').form({
        inline: true,
        fields: {
          orgName: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.orgs.name.empty')
              }
            ]
          },
          domainName: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.orgs.domainName.empty')
              }, {
                type: 'regExp[/^[a-z0-9_-]{3,16}$/gi]',
                prompt: $t('prompt.orgs.domainName.reg')
              }
            ]
          },
          zip: {
            rules: [
              {
                type: 'zipRule',
                prompt: $t('prompt.zip.reg')
              }
            ]
          }
        }
      });

      $('#form-contacts').form({
        inline: true,
        keyboardShortcuts: false,
        fields: {
          email: {
            rules: [
              {
                type: 'contactEmail',
                prompt: $t('prompt.email.invalid')
              }
            ]
          },
          email2: {
            rules: [
              {
                type: 'contactEmail',
                prompt: $t('prompt.email.invalid')
              }
            ]
          }
        }
      });

      $('#form-appearance').form({
        inline: true,
        keyboardShortcuts: false
      });

      // Run initalization actions (fetch data from server)
      LocationsService.getCountries()
        .then(data => {
          $scope.countries = data.countries;
        }, err => {
          $scope.loading = false;
          $scope.completedSearch = false;
          utils.handleApiError(err);
        });

      initOrgProperties();
      initBrandsList();
    }

    function initOrgProperties() {
      $scope.helpers.colors = config.getConfigByKey('orgColors');

      if ($scope.orgProperties) {
        angular.forEach($scope.helpers.colors, function(color) {
          let colors = $filter('filter')($scope.orgProperties, {
            'name': color.name
          }, true);
          if (colors && colors[0]) {
            color.value = colors[0].value;
          }
        });
      }
      // Backup Colors
      $scope.helpers.colorsBackup = angular.copy($scope.helpers.colors);
    }

    function initBrandsList() {
      if (!$scope.brandEditor) {
        return;
      }

      OrganizationService.getBrands()
        .then(data => {
          $scope.brands = data?.brands || [];

          // Set default brand if parent organization is not selected
          if (!$scope.helpers.selectedBrandId) {
            $scope.helpers.selectedBrandId = $scope.brands?.find(b => b.name === 'default')?.name || null;
          }
        });
    }

    function changeCountry() {
      if (!$scope.helpers.selectedCountry) {
        $scope.states = null;
        return;
      }
      $scope.states = $scope.helpers.selectedCountry.states;

      if ($scope.orgInfo && $scope.orgInfo.country && $scope.helpers.country.id === $scope.orgInfo.country.id) {
        $scope.helpers.state = $scope.orgInfo.state;
      } else {
        $scope.helpers.state = $scope.states ? $scope.states[0] : null;
      }
    }

    /**
     * Organization successfully created
     */
    function onCreateSuccess(data) {
      if (!$scope.orgInfo) {
        $scope.orgInfo = {};
      }
      angular.merge($scope.orgInfo, $scope.helpers);
      if (data.organizationId) {
        $scope.orgInfo.id = data.organizationId;
      }

      let promise;

      // Save organization properties
      if ($scope.helpers.selectedBrandId) {
        promise = saveOrgProperties(data.organizationId, [
          { name: ORG_BRAND_PROPERTY, value: $scope.helpers.selectedBrandId }
        ]);
      } else {
        promise = $q.resolve();
      }

      promise.then(() => {
        $scope.orgInfo.organizationEditor = true; // just to make security checks go right
        // Redirect user to Organization Edit UI
        utils.setStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY, $scope.orgInfo);
        $state.go('main.organizations.edit', { tab: 'admins' });
      });
    }

    function saveOrgProperties(organizationId, objects) {
      return OrganizationService.updateObjectsAndProperties(organizationId, objects)
        .catch(err => {
          $scope.loading = false;
          $scope.completedSearch = false;
          utils.handleApiError(err);
        });
    }

    function saveOrganization() {
      $('#form-basic-info').form('validate form');
      if (!$('#form-basic-info').form('is valid')) {
        return false;
      }

      let orgInfo = {
        organization: {
          name: $scope.helpers.name,
          domainName: $scope.helpers.domainName,
          addrCity: $scope.helpers.addrCity,
          zip: $scope.helpers.zip,
          addrStreet1: $scope.helpers.addrStreet1,
          addrStreet2: $scope.helpers.addrStreet2,
        }
      };

      if ($scope.helpers.selectedStateId) {
        orgInfo.organization.state = {
          'id': $scope.helpers.selectedStateId
        };
      }

      if ($scope.helpers.selectedCountryId) {
        orgInfo.organization.country = {
          'id': $scope.helpers.selectedCountryId
        };
      }

      if ($scope.helpers.selectedBrandId) {
        orgInfo.organization.brand = $scope.helpers.selectedBrandId;
      }

      let bCountry = $scope.orgInfo && orgInfo.organization && $scope.orgInfo.country && ($scope.orgInfo.country.id === $scope.helpers.selectedStateId);
      let bState = $scope.orgInfo && orgInfo.organization && (($scope.helpers.state && $scope.orgInfo.state)
        ? $scope.orgInfo.state.id === $scope.helpers.selectedStateId
        : !$scope.helpers.state);
      let bCountryFlag = angular.isUndefined(bCountry) || bCountry;
      let bStateFlag = angular.isUndefined(bState) || bState;
      if (bCountryFlag && bStateFlag && utils.compareObjects(orgInfo.organization, $scope.orgInfo, [
        'name', 'domainName',
        'addrCity', 'zip', 'addrStreet1', 'addrStreet2'
      ])) {
        return true;
      }

      $scope.loading = true;

      OrganizationService.createOrganization(orgInfo, $scope.choosedOrg ? $scope.choosedOrg.id : null)
        .then(data => {
            return onCreateSuccess(data);
          },
          err => {
            $scope.loading = false;
            $scope.completedSearch = false;
            utils.handleApiError(err);
          });
    }

    function showFeature(f) {
      return !$scope.choosedOrg || ($scope.choosedOrg.features || '').indexOf(f) !== -1;
    }

    /**
     * Switch between parent organization lists
     * 1) All available parent organizations
     * 2) Only current organization and its sub-orgs
     */
    function switchParent($event) {
      $event.stopPropagation();
      $scope.helpers.parentMode = !$scope.helpers.parentMode;
      if ($scope.helpers.parentMode) {
        $scope.parentOrgs = $filter('filter')(allOrganizations, (org) => {
          return org.id === $scope.currentOrg.id || org.id === $scope.currentOrg.parentId || org.parentId === $scope.currentOrg.id;
        });
      } else {
        $scope.parentOrgs = $filter('filter')(allOrganizations, (org) => !org.parentId);
      }
      $scope.helpers.selectedParentOrgId = $scope.currentOrg ? $scope.currentOrg.id : $scope.parentOrgs[0].id;
    }

    // #endregion
  }
}

export default angular
  .module('main.organizationsNew.controller', [])
  .controller('OrganizationsNewController', OrganizationsNewController)
  .name;
